import styled from "styled-components";

type KeyboardAccessibleProps = {
  height?: string;
  width?: string;
};

/**
 * This component is used to wrap focusable content that is only
 * meant to be shown when the user is using tab/the keyboard, for
 * when an action is otherwise hard to reach in tab order.
 */
const KeyboardAccessible = styled.div<KeyboardAccessibleProps>`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  height: 1px;
  width: 1px;

  &:focus-within {
    clip: initial;
    clip-path: initial;
    position: initial;
    width: ${({ width = "auto" }) => width};
    height: ${({ height = "auto" }) => height};
  }
`;

export default KeyboardAccessible;
